import React from 'react';
import Card from 'react-bootstrap/Card';
import { Carousel, CarouselCaption, CarouselItem } from 'react-bootstrap';


function CardAccueil(props) {
  return (
    <>
        <Carousel  style={{width:"99%"}}>
            <CarouselItem >
            <Card.Img variant="top" src="/img/bvn.jpg" style={{height:"auto", maxHeight:"700px"}} />
            <CarouselCaption>
                <h3>Bienvenue sur FootProManager {props.prenom} ! </h3>

            </CarouselCaption>
            </CarouselItem>



        </Carousel>
  

    </>
  );
}

export default CardAccueil;